export interface PrescriptionCopy {
  /** i18n key under prescriptions:print.vias.* */
  labelKey: string;
}

const COPIES_MAP: Record<string, PrescriptionCopy[]> = {
  none: [{ labelKey: "viaResponsible" }],
  antimicrobial: [
    { labelKey: "viaResponsible" },
    { labelKey: "viaPharmacy" },
  ],
  controlled_human: [
    { labelKey: "viaResponsible" },
    { labelKey: "viaPharmacy" },
  ],
  controlled_vet_mapa: [], // No PDF — redirects to SIPEAGRO
  manipulated_controlled_mapa: [
    { labelKey: "viaResponsible" },
    { labelKey: "viaEstablishment" },
    { labelKey: "viaVeterinarian" },
  ],
};

export function getPrescriptionCopies(
  regime: string | null | undefined,
): PrescriptionCopy[] {
  const key = (regime ?? "").trim() || "none";
  return COPIES_MAP[key] ?? COPIES_MAP["none"];
}
